import {guid} from '@servicenow/ui-internal';

export default function createSubscriptionId() {
	return guid();
}
